import { render, staticRenderFns } from "./access-list-guard.vue?vue&type=template&id=b6f39d66&"
import script from "./access-list-guard.vue?vue&type=script&lang=ts&"
export * from "./access-list-guard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports